import { getElementOfType } from "../utils/dom";
import { PlayerActions } from "../player/player-actions";
import { ReactiveElement } from "@nrk/reactive-element";
class KeyboardElement extends ReactiveElement {
  player;
  value;
  readyCallback() {
    this.player = getElementOfType(this);
    document.addEventListener("keydown", this);
  }
  disconnectedCallback() {
    document.removeEventListener("keydown", this);
    this.player = null;
  }
  handleEvent(event) {
    if (!this.player.focusWithin || event.defaultPrevented) {
      return;
    }
    const keyCode = event.which;
    const metaKey = event.metaKey || event.ctrlKey || event.altKey || event.shiftKey;
    const target = event.target;
    switch (keyCode) {
      case 37: {
        if (!target || target.nodeName !== "INPUT") {
          event.preventDefault();
          this.emit(
            PlayerActions.SeekToRelativeTime,
            metaKey ? -this.player.seekableStep * 5 : -this.player.seekableStep
          );
        }
        break;
      }
      case 39: {
        if (!target || target.nodeName !== "INPUT") {
          event.preventDefault();
          this.emit(
            PlayerActions.SeekToRelativeTime,
            metaKey ? this.player.seekableStep * 5 : this.player.seekableStep
          );
        }
        break;
      }
    }
    if (metaKey) {
      return;
    }
    switch (keyCode) {
      case 13:
      case 32: {
        if (target?.nodeName !== "BUTTON") {
          event.preventDefault();
          this.emit(PlayerActions.TogglePlay);
        }
        break;
      }
      case 75: {
        event.preventDefault();
        this.emit(PlayerActions.Play);
        break;
      }
      case 74: {
        event.preventDefault();
        this.emit(PlayerActions.SeekToRelativeTime, -this.player.seekableStep);
        break;
      }
      case 76: {
        event.preventDefault();
        this.emit(PlayerActions.SeekToRelativeTime, this.player.seekableStep);
        break;
      }
      case 48:
      case 49:
      case 50:
      case 51:
      case 52:
      case 53:
      case 54:
      case 55:
      case 56:
      case 57: {
        event.preventDefault();
        this.emit(PlayerActions.SeekToPosition, (keyCode - 48) / 10);
        break;
      }
      case 36: {
        event.preventDefault();
        this.emit(PlayerActions.SeekToPosition, 0);
        break;
      }
      case 35: {
        event.preventDefault();
        this.emit(PlayerActions.SeekToPosition, 1);
        break;
      }
      case 38: {
        if (!target || target.nodeName !== "INPUT") {
          event.preventDefault();
          this.emit(PlayerActions.SetVolume, this.player.volume * 100 + 10);
        }
        break;
      }
      case 40: {
        if (!target || target.nodeName !== "INPUT") {
          event.preventDefault();
          this.emit(PlayerActions.SetVolume, this.player.volume * 100 - 10);
        }
        break;
      }
      case 70: {
        break;
      }
      case 77: {
        event.preventDefault();
        this.emit(PlayerActions.ToggleMute);
        break;
      }
      case 67: {
        break;
      }
      case 80: {
        break;
      }
      case 65:
      case 90: {
        break;
      }
    }
  }
  emit(action, value) {
    this.value = value;
    this.setAttribute("action", action);
    this.dispatchEvent(new Event("change", { bubbles: true }));
  }
}
export {
  KeyboardElement
};
